import React, { useEffect, useMemo, useState } from 'react';
import { FieldControl } from 'spark-core-dx/components';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';
import { ItemServiceFactory } from '../../../../../services/ItemServiceFactory';
import { useGenericManager } from 'spark-core-dx/hooks';

export const Dataset = ({ fieldName, disabled = false }) => {
  const { visualObject, setVisualObject } = useVisualFormContext();
  const itemServiceFactory = useMemo(() => new ItemServiceFactory(), []);
  const visualMgr = useGenericManager(itemServiceFactory.ItemServiceEnum.Visual);
  const [fieldMetadata, setFieldMetadata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
   
    const load = async () => {
        if(!fieldMetadata){
        try {
                const metaResp = await visualMgr.GetMetadata({});
                const items = metaResp?.Items ?? [];
                const first = items[0];
                const fmd = first?.Fields?.find?.(x => x?.FieldName === 'DashboardDatasetId') ?? null;

                if (!fmd) {
                    if(alive) 
                        setFieldMetadata(null);
                        return;
                }

                const sd = await visualMgr.GetSelectData(fmd);

                // Normalize to DataJson (FieldControl often expects metadata.DataJson)
                const dataJson = sd?.DataJson ?? sd?.jsonData ?? sd ?? null;

                const merged = { ...fmd, DataJson: dataJson }; // keep existing props, add DataJson
                if (alive) setFieldMetadata(merged);
            } catch (err) {
                console.error('Dataset metadata load failed:', err);
                if (alive) setFieldMetadata(null);
            } finally {
                if (alive) setLoading(false);
            }
        }
    };

    load();
    return () => {
      alive = false;
    };
  }, []);


  if (!visualObject) return null;
  if (loading) return null; // or a small spinner if you prefer
  if (!fieldMetadata) return null; // nothing to render if we couldn't find the field

  return (
    <FieldControl
      fieldMetadata={fieldMetadata}
      groupId="visual"
      value={visualObject[fieldName] ?? ''}
      onChange={(evtOrValue) => {
        const nextValue =
          evtOrValue && typeof evtOrValue === 'object' && 'target' in evtOrValue
            ? evtOrValue.target?.value
            : evtOrValue;

        setVisualObject(prev => ({
          ...prev,
          [fieldName]: nextValue,
        }));
      }}
      disabled={disabled}
    />
  );
};
